var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_40_79",
    "data-name": "Component 40 \\u2013 79",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_272",
    "data-name": "Ellipse 272",
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_273",
    "data-name": "Ellipse 273",
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-edit-3",
    "data-name": "Icon feather-edit-3",
    transform: "translate(10 10.731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12030",
    "data-name": "Path 12030",
    d: "M29,31H17.75a1.25,1.25,0,0,1,0-2.5H29A1.25,1.25,0,0,1,29,31Z",
    transform: "translate(-2.25 -4.28)",
    fill: "#ec6321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12031",
    "data-name": "Path 12031",
    d: "M21.375,5.095a2.652,2.652,0,0,1,3.75,3.75L9.5,24.47l-5,1.25,1.25-5Z",
    transform: "translate(-0.25 -0.25)",
    fill: "#ec6321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12031_-_Outline",
    "data-name": "Path 12031 - Outline",
    d: "M23,2.818a3.9,3.9,0,0,1,2.759,6.661L10.134,25.1a1.25,1.25,0,0,1-.581.329l-5,1.25a1.25,1.25,0,0,1-1.516-1.516l1.25-5a1.25,1.25,0,0,1,.329-.581L20.241,3.961A3.876,3.876,0,0,1,23,2.818ZM8.611,23.091l15.38-15.38a1.4,1.4,0,0,0-1.982-1.982L6.629,21.109l-.661,2.643Z",
    fill: "#ec6321"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.babf4e8c3096fb990ad6118d4bc44d3a.svg";
export { ForwardRef as ReactComponent };